<template>
  <div>
    <colsComponentData
      v-if="options.menuName != '搜索' && options.menuName != '登录框' && options.pluginName[0] != 'loginLayoutComponent'"
    />
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="layoutComponent"
      :options="options"
      type="Data"
      :rect_id="rect_id"
      :container_id="container_id"
    />
  </div>
</template>

<script>
import colsComponentData from "../colsComponent/colsComponent-data.vue"
export default {
  components: {
    colsComponentData
  },

  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  created() {},
  methods: {
    hasComponent(name, type) {
      let com
      try {
        com = require(`components/toolbar-option-components/layoutComponent/plugin/${name}/${name}${type}.vue`)
      } catch (error) {
        return false
      }
      console.log("com :>> ", com)
      return true
    }
  }
}
</script>

 <style lang="scss" scoped>
</style>
